export default {
  data() {
    return {
      snackbar: false,
      snackbarMsg: "",
      snackbarColor: ""
    }
  },
  methods: {
    showSnackBar(msg, type) {
      this.snackbarMsg = msg;
      this.snackbar = true;

      this.snackbarColor = "success";
      switch(type) {
        case "info":
          this.snackbarColor = "info";
          break;
        case "error":
          this.snackbarColor = "error";
          break;
      }
    }
  }
}
